module.exports = vendor_library;